window.lang2 = {
    "general": {
        "language": {
            "title": "Sprache"
        },
        "accessibility": {
            "skip_to_content": "Direkt zum Inhalt",
            "close_modal": "Schließen",
            "link_messages": {
                "new_window": "Öffnet ein neues Fenster.",
                "external": "Öffnet externe Website.",
                "new_window_and_external": "Öffnet externe Website in einem neuen Fenster."
            },
            "refresh": "refrescar",
            "reset": "Reiniciar",
            "refresh_page": "Wenn Sie eine Auswahl auswählen, wird eine vollständige Seite aktualisiert",
            "selection_help": "drücken Sie die Leertaste und dann die Pfeiltasten, um eine Auswahl zu treffen",
            "unit_price_separator": "pro"
        },
        "meta": {
            "tags": "Getaggt \"{{ tags }}\"",
            "page": "Seite {{ page }}"
        },
        "404": {
            "title": "404 Seite nicht gefunden",
            "subtext": "Die von Ihnen angeforderte Seite existiert nicht.",
            "link": "Einkauf fortzusetzen"
        },
        "breadcrumbs": {
            "home": "Zuhause",
            "cart": "Einkaufswagen",
            "home_link_title": "Zurück zur Startseite"
        },
        "pagination": {
            "item": "Artikel",
            "to": "zu",
            "of": "von",
            "total": "gesamt",
            "previous": "Vorherige Seite",
            "next": "Nächste Seite",
            "item_per_page": "Artikel pro Seite",
            "current_page": "Artikel {{ current }} zu {{ pageSize }} von {{ total }} gesamt"
        },
        "password_page": {
            "opening_soon": "Eröffnet demnächst",
            "login_form_heading": "Shop mit Passwort betreten",
            "login_form_password_label": "Passwort",
            "login_form_password_placeholder": "Ihr Passwort",
            "login_form_submit": "Betreten",
            "signup_form_email_label": "E-Mail",
            "signup_form_success": "Wir senden Ihnen eine E-Mail, kurz bevor wir eröffnen!",
            "admin_link_html": "Sind Sie der Geschäftsinhaber? <a href=\"/admin\" class=\"text-link\">Melden Sie sich hier an</a>",
            "password_link": "Mit Passwort betreten",
            "powered_by_shopify_html": "Dieser Shop wird mit Hilfe von {{ shopify }} betrieben werden"
        },
        "social": {
            "share_on_facebook": "Teilen",
            "share_on_twitter": "Twittern",
            "share_on_pinterest": "Pinnen",
            "alt_text": {
                "share_on_facebook": "Auf Facebook teilen",
                "share_on_twitter": "Auf Twitter twittern",
                "share_on_pinterest": "Auf Pinterest pinnen"
            }
        },
        "search": {
            "no_results_html": "Bitte versuchen Sie einen anderen Suchbegriff oder gehen Sie zurück zur <a href=\"{{ link }}\">Startseite</a>.",
            "empty_search_message": "Suchfeld darf nicht leer sein",
            "results_with_count": {
                "one": "{{ count }} Ergebnis für \"{{ terms }}\"",
                "other": "{{ count }} Ergebnisse für \"{{ terms }}\""
            },
            "title": "Suchen Sie auf unserer Seite",
            "search": "Suchen",
            "placeholder": "Suche nach einem Produkt...",
            "submit": "Suchen",
            "close": "Schließen (esc)",
            "heading": {
                "one": "Suchergebnis",
                "other": "Suchergebnisse"
            }
        },
        "newsletter_form": {
            "newsletter_email": "Abonnieren Sie unsere Mailingliste",
            "email_placeholder": "E-Mail-Adresse",
            "confirmation": "Danke für Ihre Anmeldung!",
            "submit": "Abonnieren"
        },
        "filters": {
            "show": "Anzeigen",
            "show_more": "Mehr anzeigen",
            "show_less": "Weniger anzeigen"
        },
        "payment": {
            "method": "Zahlungsarten"
        },
        "currency": {
            "title": "Währung",
            "dropdown_label": "Währung"
        },
        "compare": {
            "title": "vergleichen Sie",
            "remove_all": "alles entfernen",
            "rating": "Bewertung",
            "description": "Beschreibung"
        },
        "faq": {
            "title": "No es posible encontrar respuestas satisfactorias?"
        }
    },
    "sections": {
        "slideshow": {
            "next_slide": "Nächster Schieber",
            "previous_slide": "Vorheriger Schieber",
            "pause_slideshow": "Diashow pausieren",
            "rotate_slideshow": "Diashow abspielen",
            "load_slide": "Folie {{ slide_number }} laden",
            "navigation_instructions": "Nutzen Sie die linken/rechten Pfeile, um durch die Slideshow zu navigieren, oder wischen Sie nach links bzw. rechts, wenn Sie ein mobiles Gerät verwenden"
        },
        "featured_product": {
            "title": "Vorgestelltes Produkt",
            "gallery_thumbnail_alt": "Laden Sie das Bild in den Galerie-Viewer, {{ imageAlt }}"
        },
        "map": {
            "address_error": "Kann die Adresse nicht finden",
            "address_no_results": "Keine Ergebnisse für diese Adresse",
            "address_query_limit_html": "Sie haben die Google- API-Nutzungsgrenze überschritten. Betrachten wir zu einem <a href=\"https://developers.google.com/maps/premium/usage-limits\">Premium-Paket</a> zu aktualisieren.",
            "auth_error_html": "Es gab ein Problem bei der Authentifizierung Ihres Google Maps-Kontos.",
            "section_heading": "Lage"
        },
        "video": {
            "play": "Video abspielen",
            "pause": "Video pausieren",
            "resume": "Video fortsetzen",
            "close": "Video schliessen"
        }
    },
    "blogs": {
        "article": {
            "sidebar_title": "Aktuelle Artikel",
            "view_all": "Alle anzeigen",
            "view_all_blogs": "Alle anzeigen Artikel",
            "all_topics": "Alle themen",
            "by_author": "von {{ author }}",
            "posted_in": "Veröffentlicht in",
            "read_more": "Weiterlesen",
            "read_more_title": "Weiterlesen: {{ title }}",
            "back_to_blog": "Zurück zu {{ title }}",
            "tags": "Stichworte",
            "previous_article": "Älterer Eintrag",
            "next_article": "Neuerer Eintrag"
        },
        "comments": {
            "title": "Hinterlassen Sie einen Kommentar",
            "name": "Name",
            "email": "E-Mail",
            "message": "Nachricht",
            "post": "Kommentar posten",
            "moderated": "Bitte beachten Sie, dass Kommentare vor der Veröffentlichung freigegeben werden müssen",
            "success_moderated": "Ihr Kommentar wurde erfolgreich gepostet. Da unser Blog moderiert wird, werden wir ihn erst kurze Zeit später veröffentlichen.",
            "success": "Ihr Kommentar wurde erfolgreich gepostet. Danke!",
            "unapproved": "Die angegebene E-Mail-Adresse ist nicht zum Posten von Kommentaren freigegeben.",
            "comments_with_count": {
                "one": "Kommentar",
                "other": "Kommentare"
            }
        }
    },
    "cart": {
        "general": {
            "title": "Einkaufswagen",
            "note": "Einen Hinweis zu Ihrer Bestellung hinzufügen",
            "remove": "Entfernen",
            "subtotal": "Zwischensumme",
            "savings": "Sie sparen",
            "taxes_and_shipping_at_checkout": "Steuern und Versandkosten werden beim Checkout berechnet",
            "taxes_and_shipping_policy_at_checkout_html": "zzgl. MwSt. und <a href=\"{{ link }}\">Versandkosten</a>",
            "taxes_included_but_shipping_at_checkout": "inkl. MwSt.",
            "taxes_included_and_shipping_policy_html": "inkl. MwSt. zzgl. <a href=\"{{ link }}\">Versandkosten</a>",
            "update": "Einkaufswagen aktualisieren",
            "checkout": "Zur kasse",
            "checkout_two": "Zur Kasse",
            "empty": "Ihr Einkaufswagen ist im Moment leer.",
            "cookies_required": "Aktivieren Sie Cookies, um den Einkaufswagen benutzen zu können",
            "edit": "Bearbeiten",
            "cancel": "Abbrechen",
            "continue_shopping": "Weiter einkaufen",
            "shipping_calculator_button": "Berechnen Sie Versandkosten",
            "shipping_calculator_calculating": "Rechnen...",
            "shipping_calculator_error_message": "Fehler: Bitte geben Sie die richtigen Versandinformationen ein",
            "shipping_calculator_success_many_rates":
                {
                    "there_are": "Es gibt",
                    "shipping_rates_available_for": "Versandkosten verfügbar für",
                    "starting_at": ", beginnt um"
                },
            "shipping_calculator_success_one_rate": "Es ist eine Versandkostenpauschale für verfügbar",
            "shipping_calculator_success_no_rate": "Für diese Bestellung und diesen Bestimmungsort ist keine Versandgebühr verfügbar.",
            "shipping_calculator_success_at": "beim"
        },
        "label": {
            "product": "Artikel",
            "price": "Preis",
            "quantity": "Menge",
            "total": "Gesamt",
            "note": "Hinweis",
            "order_summary": "Bestellübersicht"
        },
        "popup": {
            "added_to_cart": "Zum Warenkorb hinzugefügt",
            "cart_count": {
                "one": "{{ count }} Artikel",
                "other": "{{ count }} Produkte"
            },
            "product_details": "Produktdetails",
            "quantity": "Menge",
            "quantity_label": "Menge: {{ quantity_count }}"
        }
    },
    "collections": {
        "general": {
            "shop_now": "Jetzt einkaufen",
            "view_all": "Alle anzeigen",
            "show_more": "Zeig mehr",
            "view_all_label": "Sehen Sie alle Produkte in der {{ collection_name }}-Sammlung",
            "no_matches": "Es tut uns leid, aber Ihre Suche nach Produkten hat keine Treffer ergeben.",
            "items_with_count": {
                "one": "{{ count }} Produkt",
                "other": "{{ count }} Produkte"
            },
            "collection_label": "Sammlung"
        },
        "sorting": {
            "title": "Sortieren nach"
        },
        "view": {
            "title": "Ansicht als"
        },
        "filters": {
            "title_tags": "Filtern nach",
            "all_tags": "Alle Produkte",
            "refined_by": "Verfeinert von",
            "clear": "klar",
            "clear_all": "Alles löschen"
        },
        "sidebar": {
            "title": "Seitenleiste"
        }
    },
    "contact": {
        "form": {
            "name": "Name",
            "email": "E-Mail",
            "phone": "Telefonnummer",
            "message": "Nachricht",
            "submit": "Absenden",
            "post_success": "Danke, dass Sie uns kontaktiert haben. Wir werden uns so schnell wie möglich bei Ihnen melden.",
            "error_heading": "Bitte passen Sie Folgendes an:"
        }
    },
    "customer": {
        "account": {
            "title": "Mein Konto",
            "details": "Kontodetails",
            "view_addresses": "Adressen ansehen",
            "return": "Zurück zu Kontodetails"
        },
        "activate_account": {
            "title": "Konto aktivieren",
            "subtext": "Erstellen Sie ein Passwort, um Ihr Konto zu aktiveren.",
            "password": "Passwort",
            "password_confirm": "Passwort bestätigen",
            "submit": "Konto aktivieren",
            "cancel": "Einladung ablehnen"
        },
        "addresses": {
            "title": "Ihre Adressen",
            "default": "Standard",
            "add_new": "Neue Adresse hinzufügen",
            "edit_address": "Adresse bearbeiten",
            "first_name": "Vorname",
            "last_name": "Nachname",
            "company": "Firma",
            "address1": "Adresse",
            "address2": "Wohnung, Zimmer usw.",
            "city": "Stadt",
            "country": "Land",
            "province": "Bundesland",
            "zip": "PLZ",
            "phone": "Telefon",
            "set_default": "Als Standard-Adresse festlegen",
            "add": "Adresse hinzufügen",
            "update": "Adresse aktualisieren",
            "cancel": "Abbrechen",
            "edit": "Bearbeiten",
            "delete": "Löschen",
            "delete_confirm": "Sind Sie sicher, dass Sie diese Adresse löschen möchten?"
        },
        "login": {
            "helo": "Helo.",
            "title": "Anmeldung",
            "email": "E-Mail",
            "password": "Passwort",
            "forgot_password": "Haben Sie Ihr Passwort vergessen?",
            "sign_in": "Anmelden",
            "guest_title": "Als Gast fortsetzen",
            "guest_continue": "Fortsetzen",
            "intro_1": "Wenn Sie bereits registriert sind, melden Sie sich bitte an.",
            "intro_2": "Erstellen Sie Ihr Konto und genießen Sie ein neues Einkaufserlebnis."
        },
        "orders": {
            "title": "Bestellungen",
            "order_number": "Bestellung",
            "order_number_link": "Bestellnummer {{ number }}",
            "date": "Datum",
            "payment_status": "Zahlungsstatus",
            "fulfillment_status": "Lieferstatus",
            "total": "Gesamt",
            "none": "Sie haben noch keine Bestellungen aufgegeben."
        },
        "order": {
            "title": "Bestellung {{ name }}",
            "date_html": "Aufgegeben am {{ date }}",
            "cancelled_html": "Bestellung storniert am {{ date }}",
            "cancelled_reason": "Grund: {{ reason }}",
            "billing_address": "Rechnungsadresse",
            "payment_status": "Zahlungsstatus",
            "shipping_address": "Lieferadresse",
            "fulfillment_status": "Lieferstatus",
            "discount": "Rabatt",
            "shipping": "Versand",
            "tax": "Steuern",
            "product": "Artikel",
            "sku": "SKU",
            "price": "Preis",
            "quantity": "Menge",
            "total": "Gesamt",
            "fulfilled_at_html": "Geliefert am {{ date }}",
            "subtotal": "Zwischensumme",
            "track_shipment": "Sendung verfolgen"
        },
        "recover_password": {
            "title": "Passwort zurücksetzen",
            "email": "E-Mail",
            "submit": "Absenden",
            "cancel": "Abbrechen",
            "subtext": "Wir werden Ihnen eine E-Mail zum Zurücksetzen des Passworts schicken.",
            "success": "Wir haben Ihnen eine E-Mail mit einem Link zum Aktualisieren des Passworts geschickt."
        },
        "reset_password": {
            "title": "Passwort für Konto zurücksetzen",
            "subtext": "Geben Sie ein neues Passwort für {{ email }} ein",
            "password": "Passwort",
            "password_confirm": "Passwort bestätigen",
            "submit": "Passwort zurücksetzen"
        },
        "register": {
            "title": "Konto erstellen",
            "title_2": "registrieren",
            "first_name": "Vorname",
            "last_name": "Nachname",
            "email": "E-Mail",
            "password": "Passwort",
            "submit": "Erstellen",
            "register_title": "Account registrieren",
            "description": "Indem Sie ein Konto erstellen, können Sie schneller einkaufen, den Status einer Bestellung auf dem neuesten Stand halten und den Überblick über Ihre zuvor getätigten Bestellungen behalten."
        }
    },
    "homepage": {
        "onboarding": {
            "product_title": "Der Name Ihres Produkts",
            "product_description": "Diesen Abschnitt können Sie nutzen, um die Details Ihres Produkts zu beschreiben. Erzählen Sie den Kunden, wie Ihr Produkt aussieht, sich anfühlt und designt ist. Fügen Sie Einzelheiten zu Farbe, verwendeten Materialien, Größe und Produktionsort hinzu.",
            "collection_title": "Der Name Ihrer Kollektion",
            "blog_title": "Der Titel Ihres Posts",
            "blog_excerpt": "Ihr Laden hat noch keine Blogposts veröffentlicht. Ein Blog kann genutzt werden, um über die Einführung neuer Produkte, Tipps oder andere Neuigkeiten, die Sie mit Ihren Kunden teilen möchten, zu berichten. Für Inspiration und Ratschläge für Ihren eigenen Laden und Blog können Sie den E-Commerce-Blog von Shopify besuchen.",
            "blog_author": "Name des Autors",
            "no_content": "Dieser Bereich hat zur Zeit keinen Inhalt. Füge diesem Bereich über die Seitenleiste Inhalte hinzu."
        }
    },
    "layout": {
        "navigation": {
            "search": "Suchen",
            "expand": "ausklappen",
            "collapse": "einklappen",
            "menu": "Menü"
        },
        "cart": {
            "title": "Einkaufswagen",
            "items_count": {
                "one": "Produkt",
                "other": "Produkte"
            }
        },
        "customer": {
            "account": "Konto",
            "log_out": "Ausloggen",
            "log_in": "Einloggen",
            "or": "oder",
            "join": "Unirse",
            "create_account": "Konto erstellen"
        },
        "footer": {
            "social_platform": "{{ name }} auf {{ platform }}"
        }
    },
    "products": {
        "product": {
            "regular_price": "Normaler Preis",
            "sold_out": "Ausverkauft",
            "best_sellers": "Bestseller",
            "pre_order": "Hacer un pedido",
            "custom_badge": "Etikette",
            "unavailable": "Nicht verfügbar",
            "new": "Neu",
            "on_sale": "Angebot",
            "sale_price": "Sonderpreis",
            "quantity": "Menge",
            "quick_view": "Schnellansicht",
            "select_options": "wähle Optionen",
            "in_stock": "Auf Lager",
            "out_of_stock": "Ausverkauft",
            "many_in_stock": "Viele auf Lager",
            "add_to_cart": "kaufe jetzt",
            "add_all_to_cart": "Añadir todo al carrito",
            "loader_label": "Produkt wird zum Warenkorb hinzugefügt",
            "back_to_collection": "Zurück zu {{ title }}",
            "vendor": "Verkäufer",
            "quantity_minimum_message": "Die Menge muss 1 oder mehr sein",
            "include_taxes": "inkl. MwSt.",
            "shipping_policy_html": "zzgl. <a href=\"{{ link }}\">Versandkosten</a>",
            "unit_price_label": "Einzelpreis",
            "view_cart": "Einkaufswagen einsehen",
            "go_to_cart": "Einkaufswagen einsehen",
            "availability": "Verfügbarkeit",
            "product_type": "Produktcode",
            "zoom": "Klicken zum Vergrößern"
        }
    },
    "gift_cards": {
        "issued": {
            "title_html": "Hier ist Ihre {{ value }} Geschenkkarte für {{ shop }}!",
            "subtext": "Hier ist Ihre Geschenkkarte!",
            "gift_card_code": "Gutscheincode",
            "disabled": "Deaktiviert",
            "expired": "Abgelaufen am {{ expiry }}",
            "active": "Läuft ab am {{ expiry }}",
            "redeem_html": "Nutzen Sie an der Kasse diesen Code, um Ihre {{ value }} Geschenkkarte einzulösen",
            "shop_link": "Einkauf beginnen",
            "print": "Diesen Geschenkgutschein ausdrucken",
            "remaining_html": "{{ balance }} übrig",
            "add_to_apple_wallet": "Hinzufügen zu Apple Wallet",
            "qr_image_alt": "QR-Code - Scannen, um Geschenkkarte einzulösen"
        }
    },
    "wishlist": {
        "general": {
            "my_wishlist": "Meine Wunschlisten",
            "wishlist": "Wunschlisten",
            "product_image": "Bild",
            "product_name": "Produktname",
            "unit_price": "Einzelpreis",
            "share_wishlist": "Meine Wunschliste per E-Mail teilen",
            "no_login_html": "Um eine Wunschliste zu erstellen, müssen Sie <a href=\"\/account\/login\">Einloggen<\/a> oder <a href=\"\/account\/register\">ein Konto erstellen<\/a>.",
            "add_to_wishlist": "Wunschzettel",
            "remove_wishlist": "Entfernen Wunschliste",
            "note": "Bereits in Ihrer Wunschliste, gehen Sie zur Wunschliste",
            "subtext": "Um eine Wunschliste zu erstellen, müssen Sie",
            "sign_in": "Einloggen",
            "or": "oder",
            "remove": "Entfernen",
            "wishlist_empty": "Sieht so aus, als hättest du noch keine Wunschliste erstellt ...",
            "create_account": "ein Konto erstellen"
        }
    }
}
